import {useEffect, useRef, useCallback} from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
import {BraintreeError, ensureErrorResponse} from "../utils";

export const useProcessFastlanePaymentToken = (
    {
        token,
        responseTypes,
        shouldSavePayment,
        onPaymentDataFilter
    }) => {

    const currentData = useRef({token});

    useEffect(() => {
        currentData.current = {token, responseTypes};
    }, [token, responseTypes]);

    useEffect(() => {
        const unsubscribe = onPaymentDataFilter(async (data) => {
            const {
                token,
                responseTypes
            } = currentData.current;
            try {
                return {
                    meta: {
                        ...data.meta,
                        paymentMethodData: {
                            braintree_cc_nonce_key: token.id,
                            braintree_cc_save_method: shouldSavePayment
                        }
                    }
                }
            } catch (error) {
                return ensureErrorResponse(responseTypes, error);
            }
        });
        return unsubscribe;
    }, [shouldSavePayment, onPaymentDataFilter]);

}